var stepRange;

stepRange = function(options) {
  var $, actionType, calculateActives, module, moduleName, steps;
  moduleName = 'step-ranger';
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  if (module.hasClass(moduleName + "--sm-less-hidden") && $(window).width < 1024) {
    return false;
  }
  steps = module.find("." + moduleName + "__step");
  calculateActives = function(order) {
    var fillLine, filledWidth, lastActiveStep, lastIndex, pinFilledTo, sequence;
    lastIndex = 0;
    steps.each(function() {
      var thisIndex, thisStep;
      thisStep = $(this);
      thisIndex = thisStep.index();
      if (thisIndex <= order) {
        thisStep.addClass(moduleName + "__step--active");
        return lastIndex = thisIndex;
      } else {
        return thisStep.removeClass(moduleName + "__step--active");
      }
    });
    lastActiveStep = steps.eq(lastIndex);
    pinFilledTo = lastActiveStep.find("." + moduleName + "__pin");
    sequence = module.find("." + moduleName + "__sequence");
    fillLine = module.find("." + moduleName + "__fill-line");
    filledWidth = Math.round(pinFilledTo.offset().left + pinFilledTo.width() / 2) - sequence.offset().left;
    return fillLine.width(filledWidth);
  };
  actionType = options.actionType;
  switch (actionType) {
    case 'init':
      return calculateActives(0);
    case 'change':
      return calculateActives(options.order);
  }
};

module.exports = stepRange;
